import { gql } from '@lcs/shared/api';

export const getUserDetail = gql`
   query GetUserDetail($id: Int!, $extensionFilter: String, $extensionGroupFilter: String) {
      user(id: $id) {
         userId
         username
         isLocked
         name
         emailAddress
         privilegesConnection {
            items {
               userPrivilegeId
               privilegeId
               userId
               accountId
               isAdd
               isView
               isEdit
               isDelete
               isEnabled
            }
         }
         userCallRecordingExtensionsConnection {
            items {
               userCallRecordingExtensionId
               userId
               extension {
                  extensionId
                  name
                  number
               }
               isInclude
            }
         }
         userCallRecordingExtensionGroupsConnection {
            items {
               userCallRecordingExtensionGroupId
               userId
               extensionGroup {
                  extensionGroupId
                  name
                  description
               }
               extensionGroupId
               isInclude
               extensionGroupExtensionsConnection {
                  items {
                     extension {
                        extensionId
                        name
                        number
                     }
                  }
               }
            }
         }
         hasAllExtensionRecordings
         isSystemUser
         account {
            accountId
            name
            isSuspended
         }
         extension {
            extensionId
            name
            number
         }
         rolesConnection {
            items {
               userRoleId
               role {
                  roleId
                  name
                  accountId
                  rolePrivilegesConnection {
                     items {
                        privilegeId
                        accountId
                        isAdd
                        isView
                        isEdit
                        isDelete
                        isEnabled
                     }
                  }
                  roleReportsConnection {
                     items {
                        roleId
                        report {
                           reportId
                           reportDefinition
                        }
                     }
                  }
                  roleCallRecordingExtensionsConnection {
                     items {
                        roleCallRecordingExtensionId
                        roleId
                        extension {
                           extensionId
                           name
                           number
                        }
                        isInclude
                     }
                  }
                  roleCallRecordingExtensionGroupsConnection {
                     items {
                        roleCallRecordingExtensionGroupId
                        roleId
                        extensionGroupId
                        isInclude
                     }
                  }
                  hasAllExtensionRecordings
               }
            }
         }
         userReportsConnection {
            items {
               userReportId
               userId
               report {
                  reportId
                  reportDefinition
               }
            }
         }
         isActive
         isLocked
         lockoutDate
         isForcePasswordChange
         failedLoginAttempts
         lastPasswordChangeDate
         lastLoggedIn
         isAdmin
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
      extensionsConnection(filters: $extensionFilter) {
         items {
            extensionId
            number
            name
            isArchived
         }
      }
      extensionGroupsConnection(filters: $extensionGroupFilter) {
         items {
            extensionGroupId
            name
            description
         }
      }
   }
`;

export const getUserAccountId = gql`
   query GetUserAccountId($id: Int!) {
      user(id: $id) {
         accountId
      }
   }
`;
